import { HeroSection } from "@/components/home/HeroSection";
import { ServicesSection } from "@/components/home/ServicesSection";
import { IndustriesSection } from "@/components/home/IndustriesSection";
import { ApproachSection } from "@/components/home/ApproachSection";
import { HomeCTA } from "@/components/home/HomeCTA";

export default function Home() {
  return (
    <div data-testid="home-page" className="page-transition">
      <HeroSection />
      <ServicesSection />
      <IndustriesSection />
      <ApproachSection />
      <HomeCTA />
    </div>
  );
}
